module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-wrapper"
  }, [_vm._l((_vm.routes), function(item) {
    return [(!item.parentName && !item.hidden) ? _c('el-submenu', {
      attrs: {
        "index": item.name
      }
    }, [_c('template', {
      slot: "title"
    }, [(item.icon) ? _c('i', {
      class: item.icon
    }) : _vm._e(), _c('span', [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _vm._l((_vm.routes), function(child) {
      return (!child.hidden && child.parentName &&
        child.parentName === item.path) ? [(child.children && child.children.length > 0) ? _c('sidebar-item', {
        staticClass: "nest-menu",
        attrs: {
          "routes": [child]
        }
      }) : _vm._e(), _vm._v(" "), _c('router-link', {
        attrs: {
          "to": child.path
        }
      }, [_c('el-menu-item', {
        attrs: {
          "index": '/' + child.rootpath + '/' + child.path
        }
      }, [_c('span', [_vm._v(_vm._s(child.name))])])], 1)] : _vm._e()
    })], 2) : _vm._e()]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d6b1c44","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/SidebarItem.vue
// module id = 283
// module chunks = 48